import * as type from './types';

export function uploadAlbumFile(data) {
    return {
        type: type.POST_ALBUM_FILE_REQUESTED,
        data: data,
    }
}